import { IdentityTypeNameDecorator, Expose, BaseIdentity } from '@nts/std';
import { SignerSettingsIdentity } from '../../domain-models/signer-settings.identity';

@IdentityTypeNameDecorator('SignerLayoutIdentity')
export class GeneratedSignerLayoutIdentity extends SignerSettingsIdentity {

	private _signerLayoutSerial: number;

	@Expose()
	public get signerLayoutSerial(): number {
		return this.getValue<number>(() => this._signerLayoutSerial, 'signerLayoutSerial');
	}
	public set signerLayoutSerial(value: number) {
		this.setValue<number>(() => { this._signerLayoutSerial = value; }, value, 'signerLayoutSerial');
	}
}
